import gql from 'graphql-tag';

export const HOME_PAGE_MARKETING_FRAGMENT = gql`
  fragment homePageMarketing on HomePageMarketingType {
    marketingHeadline
    marketingDescription
    marketingButtonText
    marketingButtonLink
    marketingImage
  }
`;
